var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 25.3346H13.1536C12.8 25.3346 12.4609 25.1942 12.2108 24.9441C11.9608 24.6941 11.8203 24.3549 11.8203 24.0013C11.8203 23.6477 11.9608 23.3085 12.2108 23.0585C12.4609 22.8084 12.8 22.668 13.1536 22.668H29.1536C29.5073 22.668 29.8464 22.8084 30.0965 23.0585C30.3465 23.3085 30.487 23.6477 30.487 24.0013C30.487 24.3549 30.3465 24.6941 30.0965 24.9441C29.8464 25.1942 29.5073 25.3346 29.1536 25.3346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 17.3346H5.15365C4.80002 17.3346 4.46089 17.1942 4.21084 16.9441C3.96079 16.6941 3.82031 16.3549 3.82031 16.0013C3.82031 15.6477 3.96079 15.3085 4.21084 15.0585C4.46089 14.8084 4.80002 14.668 5.15365 14.668H29.1536C29.5073 14.668 29.8464 14.8084 30.0965 15.0585C30.3465 15.3085 30.487 15.6477 30.487 16.0013C30.487 16.3549 30.3465 16.6941 30.0965 16.9441C29.8464 17.1942 29.5073 17.3346 29.1536 17.3346Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 9.33464H13.1536C12.8 9.33464 12.4609 9.19416 12.2108 8.94411C11.9608 8.69406 11.8203 8.35492 11.8203 8.0013C11.8203 7.64768 11.9608 7.30854 12.2108 7.05849C12.4609 6.80844 12.8 6.66797 13.1536 6.66797H29.1536C29.5073 6.66797 29.8464 6.80844 30.0965 7.05849C30.3465 7.30854 30.487 7.64768 30.487 8.0013C30.487 8.35492 30.3465 8.69406 30.0965 8.94411C29.8464 9.19416 29.5073 9.33464 29.1536 9.33464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/alignRight.efabc7ce721be9fdfc878d26cd3c8397.svg";
export { ForwardRef as ReactComponent };